"use strict";

define(["dojo/_base/declare"], function (declare) {
  return declare([], {
    start: function start(manager) {
      manager = manager || this.manager;
      manager.setSyncEnabled(true); // start synchronizing with the server
    },

    stop: function stop(manager) {
      manager = manager || this.manager;
      manager.setSyncEnabled(false);
    },
    addManagerListeners: function addManagerListeners(manager) {
      manager = manager || this.manager;
      manager.addEventListener("rootSet", this.rootSetObserver, this);
      manager.addEventListener("rootUnset", this.rootUnsetObserver, this);
      manager.addEventListener("childMoved", this.childMovedObserver, this);
    },
    removeManagerListeners: function removeManagerListeners(manager) {
      manager = manager || this.manager;
      manager.removeEventListener("rootSet", this.rootSetObserver, this);
      manager.removeEventListener("rootUnset", this.rootUnsetObserver, this);
      manager.removeEventListener("childMoved", this.childMovedObserver, this);
    },
    addNodeListeners: function addNodeListeners(node) {
      node.addEventListener("childAdded", this.childAddedObserver, this);
      node.addEventListener("childDestroyed", this.childDestroyedObserver, this);
      node.addEventListener("propertySet", this.propertySetObserver, this);
      node.addEventListener("peerEvent", this.peerEventObserver, this);
    },
    removeNodeListeners: function removeNodeListeners(node) {
      node.removeEventListener("childAdded", this.childAddedObserver, this);
      node.removeEventListener("childDestroyed", this.childDestroyedObserver, this);
      node.removeEventListener("propertySet", this.propertySetObserver, this);
      node.removeEventListener("peerEvent", this.peerEventObserver, this);
    },
    rootSetObserver: function rootSetObserver(event) {
      this.addNodeListeners(event.target);
    },
    rootUnsetObserver: function rootUnsetObserver(event) {
      this.removeNodeListeners(event.target);
    },
    childMovedObserver: function childMovedObserver(event) {
      this.onChildMove(event);
    },
    childAddedObserver: function childAddedObserver(event) {
      this.addNodeListeners(event.data.child);
      this.onChildAdd(event);
    },
    childDestroyedObserver: function childDestroyedObserver(event) {
      this.removeNodeListeners(event.data.child);
      this.onChildDestroy(event);
    },
    propertySetObserver: function propertySetObserver(event) {
      this.onPropertySet(event);
    },
    peerEventObserver: function peerEventObserver(event) {
      this.onPeerEvent(event);
    },
    onPeerEvent: function onPeerEvent(event) {},
    onChildAdd: function onChildAdd(event) {},
    onChildDestroy: function onChildDestroy(event) {},
    onPropertySet: function onPropertySet(event) {},
    onChildMove: function onChildMove(event) {}
  });
});
//# sourceMappingURL=_PeerModelListenerMixin.js.map
